<template>
  <v-dialog
    content-class="custom-dialog"
    scrollable
    :persistent="persistent"
    :max-width="maxWidth"
    :value="value"
    @input="$emit('input', false)"
  >
    <v-card>
      <v-card-title class="px-3 py-2">
        <app-logo />
        <span>{{ title }}</span>
        <v-spacer />
        <v-btn
          color="grey darken-1"
          icon
          small
          @click="$emit('close')"
        >
          <v-icon size="16">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-3 py-5">
        <slot />
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-spacer />
        <v-btn
          v-for="(v, i) in buttons"
          :color="v.type || 'primary'"
          :disabled="v.disabled"
          :key="i"
          :loading="v.loading"
          @click.stop="v.handler"
        >
          {{ v.label }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AppLogo from '@/components/layout/AppLogo'

export default {
  name: 'BaseDialog',
  components: {
    AppLogo,
  },
  emits: ['update'],
  props: {
    buttons: {
      type: Array,
      required: true,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: Number,
      default: 500,
    },
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .custom-dialog {
    box-shadow: 0px 0px 0px 1px var(--v-grey-lighten-3),
                0px 11px 15px -7px rgba(0, 0, 0, 0.1),
                0px 9px 86px 8px rgba(12, 12, 12, 0.1),
                0px 24px 38px 3px rgba(12, 12, 12, 0.16);
  }

  .v-card {
    .v-card__title {
      gap: 12px;
      background: var(--v-grey-lighten-5);
      border-bottom: 1px solid var(--v-grey-lighten-3);
      font-size: 16px!important;
      line-height: 24px;
    }

    .v-card__text {
      display: flex;
      flex-direction: column;
      gap: 18px;
    }

    .v-card__actions {
      background: var(--v-grey-lighten-5);
      border-top: 1px solid var(--v-grey-lighten-3);
      font-size: 14px;
    }
  }
}
</style>
